import React from "react";
import { MDBRow, MDBCol } from 'mdbreact';
//import { HorizontalBar } from 'react-chartjs-2';
//import { MDBContainer } from "mdbreact";

import CanvasJSReact from '../../Assets/canvasjs.react'
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class DoughnutChart extends React.Component {
    constructor(props) {
        super()
		this.state = {
			chartData: props.chartData
		}
    }
	render() {
		const data = this.state.chartData
		const options = {
			animationEnabled: true,
			title: {
				text: "Units Health"
			},
			//subtitles: [{
			//	text: "71% Positive",
			//	verticalAlign: "center",
			//	fontSize: 24,
			//	dockInsidePlotArea: true
			//}],
			data: [{
				type: "doughnut",
				showInLegend: true,
				indexLabel: "{name}: {y}",
				yValueFormatString: "#,###'%'",
				dataPoints: data
				//dataPoints: [
				//	{ name: "Unsatisfied", y: 5 },
				//	{ name: "Very Unsatisfied", y: 31 },
				//	{ name: "Very Satisfied", y: 40 },
				//	{ name: "Satisfied", y: 17 },
				//	{ name: "Neutral", y: 7 }
				//]
			}]
		}
		return (
			<div>
				<CanvasJSChart options={options}
				/* onRef={ref => this.chart = ref} */
				/>
				{/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
			</div>
		);
    }
}

export default DoughnutChart;